<script setup>
import { useFutureStore } from '~/store/future'

const future = useFutureStore()
</script>

<template>
  <div class="pt-[120px] flex flex-col justify-center font-medium items-center text-xs">
    <div>
      {{ $t('可用余额') }}: {{ fix(future.getMarginBalanceByCode(future.curInfo?.baseM), 2) }}
    </div>
    <div class="mt-2 text-textSecondary">
      {{ $t('划转资金到合约账户开始交易') }}
    </div>
    <div class="flex items-center mt-4 space-x-4">
      <NuxtLink class="flex-none" :to="localePath(`/assets/deposit/${future.baseM}`)">
        <CommonXButton type="default" class="w-full min-w-[80px] !h-6">
          {{ $t('充值') }}
        </CommonXButton>
      </NuxtLink>
      <NuxtLink class="flex-none" :to="localePath(`/assets/transfer`)">
        <CommonXButton type="default" class="min-w-[80px] flex-none !h-6" @click="future.modal.transfer = true">
          <div>{{ $t('划转') }}</div>
        </CommonXButton>
      </NuxtLink>
      <a class="flex-none" :href="$t('contractIntroZendesk')" target="_blank" rel="nofollow">
        <CommonXButton type="default" class="w-full min-w-[80px] !h-6">
          {{ $t('合约入门') }}
        </CommonXButton>
      </a>
    </div>
  </div>
</template>
